/* eslint-disable no-console */
import { startPerfSpan, verboseLogPerfSpanEnd, notifyErrorSafely } from './userExtAnalytics/bugsnag';

const PERF_LOG_MAX_SEC = 5;
const PERF_LOG_MIN_CONSOLE_SEC = 0.5;
// Градиент: оранжевый (0s) → красный (5s)
const PERF_COLOR_ORANGE = [249, 115, 22]; // #f97316
const PERF_COLOR_RED = [220, 38, 38];     // #dc2626

function lerp(a, b, t) {
  return Math.round(a + (b - a) * Math.max(0, Math.min(1, t)));
}

function perfLogStyle(sec) {
  if (sec < 0.1) return 'color: #999; font-weight: 500';
  const t = Math.min(sec / PERF_LOG_MAX_SEC, 1);
  const r = lerp(PERF_COLOR_ORANGE[0], PERF_COLOR_RED[0], t);
  const g = lerp(PERF_COLOR_ORANGE[1], PERF_COLOR_RED[1], t);
  const b = lerp(PERF_COLOR_ORANGE[2], PERF_COLOR_RED[2], t);
  return `color: rgb(${r},${g},${b}); font-weight: 600`;
}

function isErrorLike(val) {
  return val instanceof Error || (typeof val === 'object' && val !== null && (val.message != null || val.stack != null));
}

// Normalizes args to (errorName, error, metadata). Supports:
// log.error(errorName, error, metadata)
// log.error(descriptor, error) - backward compat
// log.error(error)
// log.error(descriptor) - descriptor only
function parseErrorArgs(a, b, c) {
  let errorName = '';
  let err = null;
  let metadata = {};

  if (c !== undefined && c !== null && typeof c === 'object' && !Array.isArray(c) && !isErrorLike(c)) {
    errorName = typeof a === 'string' ? a : '';
    err = isErrorLike(b) ? b : (a !== undefined && isErrorLike(a) ? a : new Error(String(a)));
    metadata = c;
  } else if (b !== undefined && b !== null && isErrorLike(b)) {
    errorName = typeof a === 'string' ? a : '';
    err = b;
  } else if (typeof a === 'string') {
    errorName = a;
    err = a ? new Error(a) : null;
  } else if (a !== undefined && a !== null && isErrorLike(a)) {
    err = a;
  }

  return { errorName, err, metadata };
}

const log = {
  error(a, b, c) {
    const { errorName, err, metadata } = parseErrorArgs(a, b, c);

    if (errorName) console.error(errorName);
    if (err) console.error(err);
    if (err) {
      notifyErrorSafely(err, metadata, errorName);
    }
  },
  time(spanName) {
    const t0 = performance.now();
    const span = typeof startPerfSpan === 'function' ? startPerfSpan(spanName) : null;

    return {
      end() {
        try {
          const secNum = (performance.now() - t0) / 1000;
          const sec = secNum.toFixed(3);

          if (span) {
            if (span.setAttribute) span.setAttribute('perf.duration_sec', secNum);
            verboseLogPerfSpanEnd(spanName, Math.round(secNum * 1000));
            if (span.end) span.end();
          }
          if (secNum >= PERF_LOG_MIN_CONSOLE_SEC) {
            console.log(`%c[perf] ${spanName}, ${sec}s`, perfLogStyle(secNum));
          }
        } catch (e) {
          console.error('[log.time] end failed', spanName, e);
        }
      },
    };
  },
};

export default log;
export { log };
